var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:`balloon-text-${ _vm.$vuetify.theme.dark ? 'white' : 'black' }`,attrs:{"small":!_vm.large,"color":_vm.currency.color}},[_vm._v(_vm._s(_vm.currency.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }